import React, {useState} from 'react';
import Icon from '../../../assets/icons/icon';
import { timeStampToMonthDate } from '../../../utilities/timeFunctions';
import * as amplitude from "@amplitude/analytics-browser";

function Applications({details, formatDate, openLead}) {

    const isFeature984Enabled = process.env.REACT_APP_FUNNEL_FEATURE_984 === 'true'
    const [open, setOpen] = useState(false);
    const openUp=()=>{
        setOpen((prevOpen) => !prevOpen);
    }
	/**
	 * @param {PointerEvent} evt
	 */
	const rootClicked = (evt) => {
		evt.stopPropagation();
		try {
			amplitude.track(
				"Expand Section",
				{
					name: "Applications",
				}
			);
		} catch (err) {
			console.error(
				"rootClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		openUp();
	}
    return (
        <div className="quilityNestedBlockWrapper" onClick={rootClicked}>
            <div className='quilityNestedBlockHeader'>
                <div className="quilityParentBlockTitle" style={{width: '170px'}}>Applications</div>
                <span style={{marginLeft:'20px'}}>
                    <span className="typeBlock">{details.length} Apps</span>
                </span>
                <span className='quilityBlockIcon'><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
            </div>

            <div className={`detailWrapper ${open ? 'openUp' : ''}`}>
                {details.map((detail, index) => (
                    <div className="detailItem" key={"callback"+index}>
                        <span className="detailTitle">{detail.statusChangeFirst} {detail.statusChangeLast}</span>
                        <span className="detailDate">{isFeature984Enabled===true ? timeStampToMonthDate(detail.statusDate) : formatDate(detail.statusDate)}</span>
                        <span className="detailTimezone">{detail.statusName}</span>
                        <span className="ViewLead" onClick={(event) => { event.stopPropagation(); openLead(detail.statusChangeLead); }}>View Lead</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Applications;